export const changeTheme = (theme, variant) => {
  return {
    type: 'CHANGE_THEME',
    theme,
    variant
  }
}
